import { C, P0, R, S, abs, max, min } from '../../geometry';

export const bulb = {
  name: 'Bulb',
  colors: ['#161616', '#E3A008'],
  draw(m, t) {
    let pose = P0();
    const ray = (i) => {
      if (m === 'happy') return 1;
      // Thinking: the rays flicker on in sequence, like an idea forming.
      if (m === 'thinking') {
        const head = (t * 5) % 5,
          d0 = abs(i - head),
          d = Math.min(d0, 5 - d0);
        return 0.15 + 0.85 * Math.exp((-d * d) / 0.8);
      }
      if (m === 'talking') return 0.4 + 0.6 * max(0, S(t * 10));
      if (m === 'surprised') return 1;
      if (m === 'paused') return 0;
      return 0.3 + 0.1 * S(t * 1.6 + i);
    };
    const len = (i) =>
      m === 'surprised'
        ? 11
        : m === 'happy'
          ? 7 + 3 * abs(S(t * 7))
          : m === 'thinking'
            ? 4 + 7 * ray(i)
            : 7;
    if (m === 'happy') pose.ty = -2 * abs(S(t * 6));
    if (m === 'thinking') pose.rot = 4 * S(t * 1.6);
    const body = [
      [42, 66],
      [36, 56],
      [30, 44],
      [32, 30],
      [41, 21],
      [50, 19],
      [59, 21],
      [68, 30],
      [70, 44],
      [64, 56],
      [58, 66],
    ];
    const rays = [-150, -120, -90, -60, -30].map((a, i) => ({
      c: 'b',
      pts: [
        [50 + 33 * C(a * R), 40 + 33 * S(a * R)],
        [50 + (33 + len(i)) * C(a * R), 40 + (33 + len(i)) * S(a * R)],
      ],
      o: ray(i),
    }));
    return {
      strokes: [
        { c: 'a', pts: body, n: 20 },
        {
          c: 'a',
          pts: [
            [42, 71],
            [58, 71],
          ],
        },
        {
          c: 'a',
          pts: [
            [44, 77],
            [56, 77],
          ],
        },
        {
          c: 'a',
          pts: [
            [47, 83],
            [53, 83],
          ],
        },
        ...rays,
      ],
      eyes: { x: 50, y: 42 },
      pose,
    };
  },
  eyesOn: 'b',
  solid(f) {
    f.strokes[0] = { ...f.strokes[0], fill: true, c: 'b' };
    return f;
  },
};
